import React, { useState, useEffect, useMemo } from "react";
import { collection, getDocs, deleteDoc, doc, setDoc, query, orderBy, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../Config/Firebase";
import PartnerModel from "../Assets/PartnerModel";
import UnPartnerModel from "../Assets/UnPartnerModel";
import UserModel from "../Assets/UserModel";
import BlockModel from "../Assets/BlockModel";
import { useParams } from "react-router-dom";

const UsersTable = ({ isSidebarCollapsed }) => {
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [genderOption, setGenderOption] = useState("");
  const [partnerModalShow, setPartnerModalShow] = useState(false);

  const [itemToPartner, setItemToPartner] = useState(null);

  const [unpartnerModalShow, setUnpartnerModalShow] = useState(false);

  const [itemToUnpartner, setItemToUnpartner] = useState(null);

  const [userModalShow, setUserModalShow] = useState(false);

  const [itemToView, setItemToView] = useState(null);

  const [blockModalShow, setBlockModalShow] = useState(false);

  const [itemToBlock, setItemToBlock] = useState(null);
  
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25; 

  
useEffect(() => {
  if(id === "Male"){
    
  setGenderOption("Male");
  } else if (id === "Female") {
    setGenderOption("Female");
  }
  const fetchUsers = async () => {
    try {
      const q = query(
        collection(db, "users"),
        orderBy("createdAt", "desc") 
      );

      const snapshot = await getDocs(q);
      console.log("Total Users:", snapshot.size);
      const userData = snapshot.docs.map((docSnap) => ({
        docid: docSnap.id,
        ...docSnap.data(),
      }));
      const now = Date.now();
      const twentyFourHoursAgo = now - 24 * 60 * 60 * 1000;

      const recentUsers = userData.filter((user) => {
        let createdAtTime;

        if (user.createdAt?.toMillis) {
          createdAtTime = user.createdAt.toMillis();
        } else if (typeof user.createdAt === "number") {
          createdAtTime = user.createdAt;
        } else if (typeof user.createdAt === "string") {
          createdAtTime = new Date(user.createdAt).getTime();
        }

        return createdAtTime && createdAtTime >= twentyFourHoursAgo && createdAtTime <= now;
      });
      if(id === "today"){
        setUsers(recentUsers);
      } else {
        setUsers(userData);
      }
      
      console.log("Fetched users:", userData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  fetchUsers();
}, [id]);


const toggleBlock = async (user) => {
  console.log("Toggling block status for user:", user);

  try {
    const newStatus = user.isBlocked === null || user.isBlocked === undefined
      ? true  
      : !user.isBlocked; 

    // Update Firestore
    await updateDoc(doc(db, "users", user.docid), {
      isBlocked: newStatus,
    });

    
    setUsers((prev) =>
      prev.map((u) =>
        u.docid === user.docid ? { ...u, isBlocked: newStatus } : u
      )
    );
    console.log("Block status updated:", users);

  } catch (error) {
    console.error("Error during toggling block:", error);
  }

  setBlockModalShow(false);
  setItemToBlock(null);
};

  // Filtering 
  const filteredUsers = useMemo(() => {
    const today = new Date();

    let filtered = users.filter((user) => {
      const nameMatch = user.name?.toLowerCase().includes(search.toLowerCase());
      const emailMatch = user.email?.toLowerCase().includes(search.toLowerCase());
      const mobileMatch = user.mobile?.toLowerCase().includes(search.toLowerCase());

      let matchesDate = true;
      if (daysFilter) {
        let createdDate;
        if (typeof user.createdAt === "number") {
          createdDate = new Date(user.createdAt);
        } else if (user.createdAt?.seconds) {
          createdDate = new Date(user.createdAt.seconds * 1000);
        } else if (typeof user.createdAt === "string") {
          createdDate = new Date(user.createdAt);
        }

        if (createdDate && !isNaN(createdDate)) {
          const diffDays = (today - createdDate) / (1000 * 60 * 60 * 24);
          matchesDate = diffDays <= parseInt(daysFilter);
        } else {
          matchesDate = false;
        }
      }

      return (nameMatch || emailMatch || mobileMatch) && matchesDate;
    });

    if (sortOption === "name-asc") {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOption === "name-desc") {
      filtered.sort((a, b) => b.name.localeCompare(a.name));
    } else if (sortOption === "date-asc") {
      filtered.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    } else if (sortOption === "date-desc") {
      filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
    if (genderOption === "Male") {
      filtered = filtered.filter(item => item.gender === "Male");
    } else if (genderOption === "Female") {
      filtered = filtered.filter(item => item.gender === "Female");
    }

    return filtered;
  }, [users, search, daysFilter, sortOption,genderOption]);

  // Pagination
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };


  const handlePartnerClick = (id) => {
      setItemToPartner(id);
      setPartnerModalShow(true);
    };

  const confirmPartner = async () => {
    if (!itemToPartner) return;

    try {
      const userRef = doc(db, "users", itemToPartner); 
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const userData = userSnap.data();

        
        if (userData.hasOwnProperty("isPartner")) {
          await updateDoc(userRef, {
            isPartner: true
          });
        } else {
          await updateDoc(userRef, {
            isPartner: true
          });
        }

        
        setUsers(prev =>
          prev.map(item =>
            item.docid === itemToPartner
              ? { ...item, isPartner: true }
              : item
          )
        );
      } else {
        console.error("User document not found.");
      }
    } catch (error) {
      console.error("Error updating partner status:", error);
    }

    setPartnerModalShow(false);
    setItemToPartner(null);
  };

  const cancelPartner = () => {
      setPartnerModalShow(false);
      setItemToPartner(null);
    };


    const handleUnpartnerClick = (id) => {
      setItemToUnpartner(id);
      setUnpartnerModalShow(true);
    };
  
    const confirmUnPartner = async () => {
    if (!itemToUnpartner) return;

    try {
      const userRef = doc(db, "users", itemToUnpartner);
      await updateDoc(userRef, { isPartner: false });

      setUsers(prev =>
        prev.map(item =>
          item.docid === itemToUnpartner
            ? { ...item, isPartner: false }
            : item
        )
      );
    } catch (error) {
      console.error("Error removing partner status:", error);
    }

    setUnpartnerModalShow(false);
    setItemToUnpartner(null);
  };

  


    const cancelUnPartner = () => {
      setUnpartnerModalShow(false);
      setItemToUnpartner(null);
    };



      const handleViewClick = (id) => {
      setItemToView(id);
      setUserModalShow(true);
    };



        const cancelView = () => {
      setUserModalShow(false);
      setItemToView(null);
    };


      const handleBlockClick = (id) => {
      setItemToBlock(id);
      setBlockModalShow(true);
    };

            const cancelBlock = () => {
      setBlockModalShow(false);
      setItemToBlock(null);
    };






  return (
    <div className="Fee-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Users List</h2>

      
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1); 
          }}
          className="px-4 py-2 border rounded"
        />

        <select
          value={daysFilter}
          onChange={(e) => {
            setDaysFilter(e.target.value);
            setCurrentPage(1); 
          }}
          className="px-2 py-1 border rounded"
                      style={{
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage: "none",
            paddingRight: "1rem",
          }}
        >
          <option value="">All Dates</option>
          <option value="1">Last 1 Day</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="182">Last 6 Months</option>
          <option value="365">Last 1 Year</option>
        </select>
        <select
          value={genderOption}
          onChange={(e) => {
            setGenderOption(e.target.value);
            setCurrentPage(1); 
          }}
          className="px-2 py-1 border rounded"
                      style={{
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage: "none",
            paddingRight: "1rem",
          }}
        >
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
        <select
          value={sortOption}
          onChange={(e) => {
            setSortOption(e.target.value);
            setCurrentPage(1); 
          }}
          className="px-2 py-1 border rounded"
                      style={{
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage: "none",
            paddingRight: "1rem",
          }}
        >
          <option value="">Sort None</option>
          <option value="name-asc">Name Asc</option>
          <option value="name-desc">Name Desc</option>
          <option value="date-asc">Date Asc</option>
          <option value="date-desc">Date Desc</option>
        </select>
      </div>

      {/* Table */}
      <table className="w-full text-sm border temp-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Mobile</th>
            <th className="px-4 py-2 text-left">Created On</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers.length > 0 ? (
            paginatedUsers.map((user, index) => (
              <tr key={user.docid} className="border-t">
                <td className="usertable-td">
                  {(currentPage - 1) * itemsPerPage + index + 1}
                </td>
                <td className="usertable-td flex flex-wrap items-center gap-3">
                  <img
                    src={user.profileImageUrl}
                    alt="avatar"
                    className={`rounded-full${ isSidebarCollapsed ? " w-10 h-10 " : " w-6 h-6 " }`}
                  />
                  <span>{user.name}</span>
                </td>
                <td className="usertable-td">{user.mobile}</td>
                <td className="usertable-td">{formatDateTime(user.createdAt)}</td>
                <td className="usertable-td">
                  <div className="flex flex-wrap gap-2">
                    <button
                      onClick={() => handleViewClick(user.docid)}
                      className="px-2 py-1 text-xs rounded bg-yellow-500 text-white"
                    >
                      View Data
                    </button>
                    {user.isPartner ? (
                      <button
                        onClick={() => handleUnpartnerClick(user.docid)}
                        className="px-2 py-1 text-xs rounded bg-red-500 text-white"
                      >
                        Unpartner
                      </button>
                    ) : (
                      <button
                        onClick={() => handlePartnerClick(user.docid)}
                        className="px-2 py-1 text-xs rounded bg-green-500 text-white"
                      >
                        Partner
                      </button>
                    )}

                    <button
                      onClick={() => handleBlockClick(user.docid)}
                      className={`px-2 py-1 text-xs rounded text-white ${
                        user?.isBlocked ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"
                      }`}
                    >
                      {user?.isBlocked ? "Unblock" : "Block"}
                    </button>
                  </div>
                  
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center py-4 text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-center items-center gap-2 mt-4">
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          Prev
        </button>
        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>
        
        <button
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>

      {partnerModalShow && (
        <PartnerModel
          itemName={users.find((p) => p.docid === itemToPartner)?.name || "Unknown User"}
          onClose={cancelPartner}
          onConfirm={confirmPartner}
        />
      )}

      {unpartnerModalShow && (
        <UnPartnerModel
          itemName={users.find((p) => p.docid === itemToUnpartner)?.name || "Unknown User"}
          onClose={cancelUnPartner}
          onConfirm={confirmUnPartner}
        />
      )}

      {userModalShow && (
        <UserModel
          user={users.find((p) => p.docid === itemToView) || null}
          onClose={cancelView}
        />
      )}
      {blockModalShow && (
        <BlockModel
          user={users.find((p) => p.docid === itemToBlock) || null}
          onClose={cancelBlock}
          onBlock={() => toggleBlock(users.find((p) => p.docid === itemToBlock))}
        />
      )}

    </div>
  );
};

export default UsersTable;



// Format of date-time 
const formatDateTime = (value) => {
  if (!value) return "";
  let date;
  if (typeof value === "number") {
    date = new Date(value);
  } else if (value?.seconds) {
    date = new Date(value.seconds * 1000);
  } else if (typeof value === "string") {
    date = new Date(value);
  }
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
